/** Convert a profession name to a URL-safe slug. Must be used consistently everywhere slugs are generated or matched. */
export function professionToSlug(name: string): string {
  return name
    .toLowerCase()
    .replace(/[()]/g, '')     // remove parentheses
    .replace(/\//g, '-')      // slash → dash
    .replace(/\s+/g, '-')     // spaces → dash
    .replace(/-+/g, '-')      // collapse multiple dashes
    .replace(/^-|-$/g, '');   // trim leading/trailing dashes
}
